var _path, _polygon, _path2, _polygon2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _circle2, _circle3, _circle4, _path12, _path13, _path14, _path15, _circle5, _path16, _path17, _path18, _path19, _path20, _circle6, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingAddAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 655.27173,
    height: 556.25,
    viewBox: "0 0 655.27173 556.25",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M830.688,362.53653c7.01074,13.78357,12.536,28,28,28a28,28,0,0,0,0-56C842.97217,334.33975,817.63916,336.88113,830.688,362.53653Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "580.332 527.399 568.366 530.065 552.386 485.179 570.047 481.243 580.332 527.399",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M858.33323,710.19322l-38.58409,8.59828-.10877-.488a15.386,15.386,0,0,1,11.67075-18.365l.001-.00022,23.56577-5.25143Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "615.88 543.442 603.62 543.442 597.787 496.154 615.882 496.155 615.88 543.442",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M891.3702,727.20159l-39.53051-.00147v-.5a15.38605,15.38605,0,0,1,15.38647-15.38623h.001l24.1438.001Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M888.32544,690.53653H872.67822a4.51721,4.51721,0,0,1-4.45849-3.89063l-14.1836-109.71679a1.5,1.5,0,0,0-2.93481-.18457l-8.40576,31.3291,7.5769,71.35156a4.49586,4.49586,0,0,1-3.45825,4.90332l-12.41162,2.86426a4.52171,4.52171,0,0,1-5.30347-3.03125l-19.98779-69.36621a39.109,39.109,0,0,1-1.62695-15.74707l6.25341-62.53418.47437.02344,83.49267,4.02343-4.88208,145.63282A4.48341,4.48341,0,0,1,888.32544,690.53653Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 584.9459,
    cy: 194.64578,
    r: 24.56103,
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M895.83472,547.29629c-.08081,0-.16187-.00195-.24341-.00683l-83.24609-4.47559a4.49852,4.49852,0,0,1-4.04175-5.87207l6.58862-20.459a132.35831,132.35831,0,0,0,3.49658-67.876,42.3621,42.3621,0,0,1,7.52515-34.14453,41.73425,41.73425,0,0,1,30.15967-16.64648h.00024q.61158-.04835,1.2273-.08594a42.1719,42.1719,0,0,1,44.19433,48.35058l-5.80444,38.97266,4.62744,57.38184a4.49963,4.49963,0,0,1-4.48364,4.86132Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M793.3985,552.47593a10.05576,10.05576,0,0,0,1.57-15.33919l16.02843-31.93852L792.556,507.38181l-12.39368,29.99458a10.11027,10.11027,0,0,0,13.23614,15.09954Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#a0616a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M903.43379,557.68069a10.05577,10.05577,0,0,1,1.01549-15.38585l-10.46566-34.168,17.81664,5.2346,7.20688,31.644a10.11027,10.11027,0,0,1-15.57335,12.67526Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M901.70142,539.78165a4.47685,4.47685,0,0,1-4.45533-3.90918l-8.32763-62.82325-13.28589-49.09277a14.18778,14.18778,0,0,1,13.34692-17.88867h0a14.24365,14.24365,0,0,1,14.33374,11.7959L923.10767,533.808a4.50073,4.50073,0,0,1-4.2461,5.25293l-16.9646.7168C901.83154,539.77969,901.76636,539.78165,901.70142,539.78165Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M802.322,532.726a4.60027,4.60027,0,0,1-.95752-.10156l-16.6062-3.541a4.49992,4.49992,0,0,1-3.30835-5.88867L820.3418,412.18887a14.26531,14.26531,0,0,1,16.10376-9.23535h0a14.18889,14.18889,0,0,1,10.16968,19.86817l-21.32666,46.24316-18.6858,60.4873A4.47424,4.47424,0,0,1,802.322,532.726Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M831.24694,352.64019A33.40494,33.40494,0,0,0,850.33762,358.54a20.47093,20.47093,0,0,1-8.11361,3.338,67.35875,67.35875,0,0,0,27.514.1546,17.80736,17.80736,0,0,0,5.75978-1.97824,7.28919,7.28919,0,0,0,3.55521-4.7547c.60365-3.44852-2.08348-6.58157-4.876-8.69308a35.96737,35.96737,0,0,0-30.22447-6.03968c-3.37626.87272-6.75852,2.34726-8.9515,5.05866s-2.84257,6.8915-.75322,9.68353Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M703.08435,171.875h-422a8.72772,8.72772,0,0,0-8.72022,8.72v411.32a8.72777,8.72777,0,0,0,8.72022,8.72h37v-2.49h-37a6.23726,6.23726,0,0,1-6.23-6.23V180.595a6.23724,6.23724,0,0,1,6.23-6.23h422a6.23974,6.23974,0,0,1,6.24023,6.23v411.32a6.17925,6.17925,0,0,1-1.03027,3.42,6.446,6.446,0,0,1-2.35986,2.12,6.18583,6.18583,0,0,1-2.8501.69h-37v2.49h37a8.71218,8.71218,0,0,0,6.62988-3.06,1.94636,1.94636,0,0,0,.18994-.24,8.15272,8.15272,0,0,0,1.25-2.11,8.49852,8.49852,0,0,0,.66016-3.31V180.595A8.7298,8.7298,0,0,0,703.08435,171.875Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.24228,
    y: 34.95306,
    width: 436.95676,
    height: 2.49281,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.43119,
    cy: 18.69995,
    r: 7.47844,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9317,
    cy: 18.69995,
    r: 7.47844,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4322,
    cy: 18.69995,
    r: 7.47844,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M597.58862,264.5308h-211a13,13,0,0,1,0-26h211a13,13,0,0,1,0,26Zm-211-24a11,11,0,0,0,0,22h211a11,11,0,0,0,0-22Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M651.0885,446.125h-318a17.01917,17.01917,0,0,1-17-17v-102a17.01917,17.01917,0,0,1,17-17h318a17.01917,17.01917,0,0,1,17,17v102A17.01917,17.01917,0,0,1,651.0885,446.125Zm-318-134a15.017,15.017,0,0,0-15,15v102a15.017,15.017,0,0,0,15,15h318a15.017,15.017,0,0,0,15-15v-102a15.017,15.017,0,0,0-15-15Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M533.78946,372.625h-111a8,8,0,1,1,0-16h111a8,8,0,0,1,0,16Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#31c48d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78946,399.625h-214a8,8,0,1,1,0-16h214a8,8,0,0,1,0,16Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#31c48d"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.02364,
    cy: 206.25,
    r: 30,
    fill: "#31c48d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M636.7776,432.125h-28a8,8,0,1,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M636.7776,432.125h-28a8,8,0,1,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M651.08435,494.125h-318a17.0241,17.0241,0,0,0-17,17v102a17.0241,17.0241,0,0,0,17,17h318a17.01783,17.01783,0,0,0,17-17v-102A17.01783,17.01783,0,0,0,651.08435,494.125Zm15,119a15.012,15.012,0,0,1-15,15h-318a15.01828,15.01828,0,0,1-15-15v-102a15.01828,15.01828,0,0,1,15-15h318a15.012,15.012,0,0,1,15,15Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M533.78946,556.625h-111a8,8,0,1,1,0-16h111a8,8,0,0,1,0,16Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#31c48d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M636.78946,583.625h-214a8,8,0,1,1,0-16h214a8,8,0,0,1,0,16Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#31c48d"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.02364,
    cy: 390.25,
    r: 30,
    fill: "#31c48d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M636.7776,616.125h-28a8,8,0,1,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M926.63587,728.125h-140a1,1,0,0,1,0-2h140a1,1,0,1,1,0,2Z",
    transform: "translate(-272.36413 -171.875)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingAddAccounts);
export default __webpack_public_path__ + "static/media/onboarding-add-accounts.2c23e26e9de4562521496bdc5390a1b1.svg";
export { ForwardRef as ReactComponent };